export default __webpack_public_path__ + "static/iphonex-tutoring-9e08c9a6ad34c67f5ec45143eadb42c0.png";